import { FaFolder } from "react-icons/fa";
import { Row, Col, } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
export const SignaturedContracts = (props) => {
    const navigate = useNavigate()
    return (

        <Row>
            {
                props.shardFiles && props.shardFiles.length > 0 ?
                props.shardFiles.map(curr => {
                        return (
                                <Col sm="3" key={new Date().getSeconds()} onClick={() => { navigate(`/contracts/${curr._id}`) }}>
                                    <div className="file_card crd_orng mb-3">
                                        <div className="fldr_icn txt_orng">
                                            <FaFolder />
                                        </div>
                                        <h5>
                                            {curr.school_name}
                                        </h5>
                                        {/* <p>900 files</p> */}
                                    </div>
                                </Col>
                        )
                    })
                    :
                    <Col sm="12">
                        <div className="file_card mb-3" style={{ textAlign: "center" }}>

                            No Shared Folder or Files
                        </div>
                    </Col>
            }
       
        </Row >
    )
}